var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseButtonWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.5,
    transform: "rotate(-180 22 22)",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3536 13.6464C14.1583 13.4512 13.8417 13.4512 13.6464 13.6464C13.4512 13.8417 13.4512 14.1583 13.6464 14.3536L14.3536 13.6464ZM29.6464 30.3536C29.8417 30.5488 30.1583 30.5488 30.3536 30.3536C30.5488 30.1583 30.5488 29.8417 30.3536 29.6464L29.6464 30.3536ZM13.6464 14.3536L29.6464 30.3536L30.3536 29.6464L14.3536 13.6464L13.6464 14.3536Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6464 29.6464C13.4512 29.8417 13.4512 30.1583 13.6464 30.3536C13.8417 30.5488 14.1583 30.5488 14.3536 30.3536L13.6464 29.6464ZM30.3536 14.3536C30.5488 14.1583 30.5488 13.8417 30.3536 13.6464C30.1583 13.4512 29.8417 13.4512 29.6464 13.6464L30.3536 14.3536ZM14.3536 30.3536L30.3536 14.3536L29.6464 13.6464L13.6464 29.6464L14.3536 30.3536Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButtonWhite);
export default __webpack_public_path__ + "static/media/close-button-white.21404a3be6d52f7bb5fb38de0c7f27a6.svg";
export { ForwardRef as ReactComponent };